import styled from "styled-components";

/* One page header for the whole app shell.
 *
 * Each screen had grown its own: the reservations page used a 20px/850 title
 * with no rule at all on desktop, notifications a 22px/700 title with one, and
 * settings a 22-28px/750 title with none. Same product, three different
 * answers to the same question, so the pages did not look related.
 *
 * PageHeaderBar is the row: title on the left, whatever the page needs on the
 * right, and the hairline underneath that separates the header from the page.
 */
export const PageHeaderBar = styled.header`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 2px 0 12px;
  margin-bottom: 16px;
  border-bottom: 1px solid #e7eeea;

  @media (max-width: 768px) {
    gap: 8px;
    padding: 2px 0 9px;
    margin-bottom: 12px;
  }
`;

export const PageHeaderTitle = styled.h1`
  margin: 0;
  min-width: 0;
  color: var(--app-orange, #ee754c);
  font-size: 22px;
  font-weight: 750;
  line-height: 1.2;
  letter-spacing: -0.025em;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

/* The line under a title that says what the page is for. */
export const PageHeaderDescription = styled.p`
  margin: 6px 0 0;
  color: #75857d;
  font-size: 13px;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 12.5px;
  }
`;

export const PageHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    gap: 4px;
  }
`;

/* Title and description together, so the actions stay opposite the pair
   rather than opposite the title alone. */
export const PageHeaderMain = styled.div`
  min-width: 0;
`;
